import { TJClass } from "src/app/shared/models/class.model";
import { LocalStorageKeys } from "../../home/context-selector/context-selector.component";
import { GraphqlService } from "src/app/services/graphql/graphql.service";
import { ClassesService } from "src/app/services/classes/classes.service";
import { LocalStorageService } from "src/app/services/local-storage/local-storage.service";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class GradeSelectingService {

  public constructor(
    private graphqlService: GraphqlService,
    private classesService: ClassesService,
    private localStorageService: LocalStorageService
  ) { }

  public async getMostCommonStudentGrade(): Promise<string> {

    let currentClass = await this.classesService.getSelectedClass();
    if (!currentClass) {
      let classes = await this.classesService.getClasses();
      let cachedClass = this.getCachedClass(classes);
      if (cachedClass) {
        currentClass = cachedClass;
      }
      else {
        currentClass = classes[0];
      }
    }

    const studentGrades = (await this.graphqlService.getStudentGradesDataForClass(currentClass.classRenaissanceId))?.studentEnrollments || [];

    const gradeCount: { [key: string]: number } = {};

    studentGrades.forEach(student => {
      const grade = student.grade;
      if (grade) {
        gradeCount[grade] = (gradeCount[grade] || 0) + 1;
      }
    });

    let mostCommonGrade = Object.keys(gradeCount).reduce((a, b) => gradeCount[a] > gradeCount[b] ? a : b, '');

    // Remove leading zeros from the most common grade
    return mostCommonGrade.replace(/^0+/, '');
  }

  private getCachedClass(classes: TJClass[]): TJClass | null {
    const storedClassId = this.localStorageService.getItem(LocalStorageKeys.selectedClassId);
    const storedClass = classes.find(cls => cls.classRenaissanceId === storedClassId);

    if (!storedClass) {
      return null;
    }

    return storedClass;
  }
}
